import React, { useEffect } from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { observer, inject } from "mobx-react";
import Store from "../../state/store";
import Actions from "../../state/actions";
import { VideoPlayer, StandardButton } from "../../components";
import { findItemAndIndexById } from "../../utils";
import { SectionVideo } from "../../types";
import { VideoPageContainer, SectionDescription } from "./Video.style";

interface Props extends RouteComponentProps {
  idSection: string;
  store?: Store;
  mutator?: Actions;
}

const VideoPage: React.FC<Props> = (props) => {
  const { content } = props.store!;
  const sectionItemAndIndex = findItemAndIndexById(
    props.idSection,
    content.sections
  );
  const section = sectionItemAndIndex.item as SectionVideo;

  const nextSection = content.sections[sectionItemAndIndex.index + 1];

  useEffect(() => {
    props.mutator!.completeSection(props.idSection);
  }, []);

  return (
    <VideoPageContainer>
      <SectionDescription>{section.description}</SectionDescription>
      <VideoPlayer
        video={section.video.url}
        subtitle={section.video.subtitle}
      />
      {nextSection && (
        <div style={{ marginTop: "1em", marginBottom: "2em", alignSelf: "flex-end", marginRight: "20%" }}>
          <Link to={`/section/${nextSection.id}`}>
            <StandardButton textButton={nextSection.title} />
          </Link>
        </div>
      )}
    </VideoPageContainer>
  );
};

export default inject("store", "mutator")(observer(VideoPage));
